export const DEFAULT_TYPE_OPTION = { label: 'All Types', value: 'All' };
export const DEFAULT_STATUS_OPTION = { label: 'All On', value: 'Allon' };

export const TYPE_OPTIONS = [
  DEFAULT_TYPE_OPTION,
  { label: 'Base', value: 'Base' },
  { label: 'Custom', value: 'Custom' },
  { label: 'Supplier Blend', value: 'Supplier Directed Blend' },
];

export const STATUS_OPTIONS = [
  DEFAULT_STATUS_OPTION,
  { label: 'All Off', value: 'Alloff' },
  { label: 'All Statuses', value: 'Allstatuses' },
];

export const DEFAULT_SELF_AUTH_FILTERS = {
  location: [],
  product: [],
  status: DEFAULT_STATUS_OPTION,
  type: DEFAULT_TYPE_OPTION,
};
